import { useEffect } from 'react';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import { Box, Container, Divider, Tab, Tabs, Typography } from '@mui/material';
import gtm from '../lib/gtm';

const tabs = [
  {
    href: '/dashboard/analysis',
    label: '6つの指標'
  },
  {
    href: '/dashboard/analysis/transition',
    label: '推移'
  },
  {
    href: '/dashboard/analysis/setting',
    label: '部署の設定'
  }
];

export const Reports = () => {
  const location = useLocation();

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        flexGrow: 1
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ py: 2 }}>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex'
            }}
          >
            <Typography
              color="textPrimary"
              variant="h4"
            >
              分析
            </Typography>
          </Box>
          <Tabs
            allowScrollButtonsMobile
            // sx={{ mt: 2 }}
            value={tabs.findIndex((tab) => tab.href === location.pathname)}
            variant="scrollable"
          >
            {tabs.map((option) => (
              <Tab
                component={RouterLink}
                key={option.href}
                label={option.label}
                to={option.href}
              />
            ))}
          </Tabs>
          <Divider />
        </Box>
        <Outlet />
      </Container>
    </Box>
  );
};
